import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

import localConfig from './config.json';
import { ConfigContext, ClientConfig, ServerConfig } from './Config.model';
import { get } from './utils/Request';

const ConfigurationContext = createContext<ConfigContext>({
  clientConfig: null,
  serverConfig: null,
  isClientConfigLoad: false,
  isServerConfigLoad: false,
});

export const useConfig = (): ConfigContext => useContext(ConfigurationContext);

const useProvideConfig = (): ConfigContext => {
  const [isClientConfigLoad, setIsClientConfigLoad] = useState<boolean>(false);
  const [isServerConfigLoad, setIsServerConfigLoad] = useState<boolean>(false);
  const [clientConfig, setClientConfig] = useState<ClientConfig | null>(null);
  const [serverConfig, setServerConfig] = useState<ServerConfig | null>(null);

  // Load clientConfig
  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      setClientConfig(localConfig);
      setIsClientConfigLoad(true);
    } else {
      axios.get<ClientConfig>('/config.json').then((response) => {
        setClientConfig(response.data);
        setIsClientConfigLoad(true);
      });
    }
  }, []);

  // Load serverConfig
  useEffect(() => {
    if (isClientConfigLoad && !isServerConfigLoad) {
      get<ServerConfig>(`${clientConfig?.host}/application/config`).then((data) => {
        setServerConfig(data);
        setIsServerConfigLoad(true);
      });
    }
  }, [isClientConfigLoad]);

  return {
    isClientConfigLoad,
    isServerConfigLoad,
    clientConfig,
    serverConfig,
  };
};

interface Props {
  children: JSX.Element | JSX.Element[];
}

export function ProvideConfiguration({ children }: Props): JSX.Element {
  const config = useProvideConfig();

  return (
    <ConfigurationContext.Provider value={config}>
      {children}
    </ConfigurationContext.Provider>
  );
}
